export default "__VITE_ASSET__d59878ee__"